import { ThemeOverride } from '@chakra-ui/react';

export const shadows: ThemeOverride['shadows'] = {
  header: '0 1px 5px rgba(25, 25, 30, 0.05)',
  bottomNav: '0 -1px 5px rgba(25, 25, 30, 0.05)',
  spread: '0 0 15px rgba(25, 25, 30, 0.05)',
  text: '1px 1px 0 #000000, -1px -1px 0 #000000, -1px 1px 0 #000000, 1px -1px 0 #000000, 0px 1px 0 #000000,  0-1px 0 #000000, -1px 0 0 #000000, 1px 0 0 #000000',
};
